export enum CallVideoFilterType {
  None = 'none',
  BackgroundBlur = 'background-blur',
  VirtualBackground = 'virtual-background',
}

